const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 20;

export class PasswordPolicy {
  public maxPasswordLength : number;
  public minPasswordLength : number;
  public numbersRequired : boolean;
  public upperCaseRequired : boolean;
  public lowerCaseRequired : boolean;
  public specialCharRequired : boolean;
  public limitRepeating : boolean;
  public limitAdjacent : boolean;
  public excludeCharList : string;

    constructor(maxPasswordLength? : number,
      minPasswordLength? : number,
      numbersRequired? : boolean,
      upperCaseRequired? : boolean,
      lowerCaseRequired? : boolean,
      specialCharRequired? : boolean,
      limitRepeating? : boolean,
      limitAdjacent? : boolean,
      excludeCharList? : string) {
      this.maxPasswordLength = maxPasswordLength || MAX_PASSWORD_LENGTH;
      this.minPasswordLength = minPasswordLength || MIN_PASSWORD_LENGTH;
      this.numbersRequired = numbersRequired || false;
      this.upperCaseRequired = upperCaseRequired || false;
      this.lowerCaseRequired = lowerCaseRequired || false;
      this.specialCharRequired = specialCharRequired || false;
      this.limitRepeating = limitRepeating || false;
      this.limitAdjacent = limitAdjacent || false;
      this.excludeCharList = excludeCharList || "" ;
  }
}

